import {Component, Input, ViewEncapsulation } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { StripTagsPipe } from 'ngx-pipes';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class PageHeaderComponent {

  _header: any;

  get header(): any {
      return this._header;
  }
  @Input() set header(value: any) {
      this._header = value;
      if (!this.header.noMeta) {
        this.title.setTitle(`${this.stripTags.transform(this.header.title)} ${this.header.business? ' | Biznes' : ''} | Salon Expert L'Oréal Professionnel`);
        // this.title.setTitle(`${this.stripTags.transform(this.header.title)} ${this.header.business? ' | Biznes' : ''} | Salon Expert L'Oréal Professionnel`);
        if (this.header.text) {
          this.meta.updateTag({name: 'description', content: this.header.text});
        } else {
          this.meta.updateTag({name: 'description', content: ''});
        }

      }
  }

  background = Math.floor(Math.random() * 4);

  constructor(
    private readonly title: Title,
    private readonly meta: Meta,
    private readonly stripTags: StripTagsPipe,
  ) {}

  replace(str) {
    const regex = / \| /gm;
    return str.replace(regex, '');
  }


}
